import Swal from 'sweetalert2';
import { Box, Button, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import Api from '../../../../../Services/Api';

export default function QuestionsTextAreaArena251({ title, idPesquisa }) {
	const theme = useTheme();
	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const [questionText, setQuestionText] = useState('');
	const [isDisabled, setIsDisabled] = useState(false);

	const handleSendQuestion = async () => {
		if (questionText?.length < 15) {
			return Swal.fire({
				title: 'Atenção',
				text: 'A pergunta deve ter pelo menos 15 caracteres.',
				icon: 'warning',
				confirmButtonText: 'OK',
			});
		}

		const body = {
			id_pesquisa: idPesquisa,
			id_aluno: 0,
			nome: '',
			email: '',
			telefone: '',
			respostas: [{ pergunta: `${title}`, resposta: questionText }],
			complementos: [''],
		};

		trackPromise(Api.post('Pesquisas', body))
			.then((response) => {
				if (response) {
					Swal.fire({
						title: 'Pergunta enviada com sucesso!',
						text: 'Obrigado.',
						icon: 'success',
						confirmButtonText: 'OK',
					}).then((result) => {
						if (result.isConfirmed) {
							setIsDisabled(true);
						}
					});
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<Grid
			xs={12}
			sx={{ paddingTop: 3 }}
		>
			<Typography
				variant={'h3'}
				fontFamily={'Poppins'}
				fontSize={'18px'}
				fontWeight={700}
				lineHeight={1.2}
				color={'#959595'}
			>
				{title}
			</Typography>
			<Box
				sx={{ borderRadius: '4px', marginY: 1, padding: '1px' }}
				className={'background-revalida-ldl'}
			>
				<TextField
					disabled={isDisabled}
					onChange={(e) => setQuestionText(e.target.value)}
					multiline
					rows={4}
					variant={'outlined'}
					style={{
						width: 'calc(100% - 1px)',
						minHeight: '82px',
						backgroundColor: '#151414',
						borderRadius: '4px',
					}}
					sx={{
						'.MuiOutlinedInput-root': {
							color: 'white',
							fontFamily: 'Poppins',
						},
					}}
				/>
			</Box>
			<Box
				sx={{
					width: '100%',

					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
				}}
			>
				<Button
					disabled={isDisabled}
					onClick={() => handleSendQuestion()}
					fullWidth={matchesMobile ? true : false}
					sx={{
						borderRadius: 32,
						paddingX: 5,
						fontFamily: 'Poppins',
						fontSize: '12px',
						color: 'white',
					}}
					className={'background-revalida-ldl'}
				>
					Enviar resposta
				</Button>
			</Box>
		</Grid>
	);
}
